/** @format */
import {CustomDotProps} from './types';

const CustomDot = (props: CustomDotProps) => {
  const {cx, cy, payload} = props;
  const color = payload?.color || '#fff';
  const radius = 20; // 40px диаметр = 20px радиус
  const name = payload?.name || '';

  return (
    <g>
      <circle cx={cx} cy={cy} r={radius} fill={color} />
      <text
        x={cx}
        y={cy}
        textAnchor='middle'
        dominantBaseline='central'
        fill='#fff'
        fontSize='14'
        fontWeight='600'
      >
        {name}
      </text>
    </g>
  );
};

export default CustomDot;

